export default __webpack_public_path__ + "static/media/Asset 23.e0d22abd.png";